import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MechanicsService } from 'src/app/_services/mechanics.service';
import { NotificationsService } from 'src/app/_services/notifications.service';

@Component({
  selector: 'app-auth-notifications-list',
  standalone: false,
  templateUrl: './auth-notifications-list.component.html'
})
export class AuthNotificationsListComponent implements OnInit {

  notifications: any;
  visible: boolean = false;
  newNotifications: number = 0;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public ms: MechanicsService,
    private notificationsService: NotificationsService
  ) { }

  ngOnInit(): void {
    this.notificationsService.getNotifications().subscribe((notificationsResponse) => {
      this.notifications = notificationsResponse;
      if (this.notifications && Array.isArray(this.notifications)) {
        this.newNotifications = this.notifications.filter(x => !x.isRead).length
      }
    });
  }

  markAsRead(notification: any) {
    notification.isRead = true;
    this.route.params.subscribe((params) => {
      const officeCode =
        params['officeCode'] || this.ms.getCurrentOffice() || 'default';
      const langCode = params['langCode'] || 'en';
      this.router.navigate([`/${officeCode}/${langCode}/notifications/${notification.id}`]);
    });
  }

  openAcknowledgeDialog(item) {
    this.visible = true;
  }

  sendAcknowledment(notification: any) {
    
  }

  deleteNotification(notification: any) {
    this.notifications = this.notifications.filter(x => x.id !== notification.id);
  }
}
